import { useEffect, useRef } from 'react'
import confetti from 'canvas-confetti'
import { useAppStore } from '../store/appStore'

/** 品牌色彩带 */
const COLORS = ['#b8835a', '#f5efe2', '#ffd28a', '#ff8c42', '#ffffff', '#e8c89a', '#c4956a']

function burst(originX: number, originY: number, count = 120, spread = 70, angle = 90) {
  confetti({
    particleCount: count,
    origin: { x: originX, y: originY },
    spread,
    angle,
    colors: COLORS,
    startVelocity: 38,
    gravity: 1.1,
    ticks: 220,
    scalar: 1.1,
    shapes: ['square', 'circle'],
    drift: 0,
    disableForReducedMotion: true,
  })
}

/**
 * 监听 fireworksTrigger 计数器，用 canvas-confetti 做彩带特效。
 * 纯 DOM 组件，不需要挂在 Three.js Canvas 内。
 */
export function Fireworks() {
  const trigger = useAppStore((s) => s.fireworksTrigger)
  const prevTrigger = useRef(0)

  useEffect(() => {
    if (trigger === 0 || trigger === prevTrigger.current) return
    prevTrigger.current = trigger

    // 中心爆炸
    burst(0.5, 0.55, 130, 80)

    // 左右炮
    const t1 = setTimeout(() => burst(0.15, 0.6, 90, 55, 60), 250)
    const t2 = setTimeout(() => burst(0.85, 0.6, 90, 55, 120), 250)

    // 收尾
    const t3 = setTimeout(() => burst(0.5, 0.5, 60, 120), 600)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t3)
    }
  }, [trigger])

  return null
}
